import React, { useState } from "react";
import styles from "./LibroReclamaciones.module.css";

export default function LibroReclamaciones() {
  const [form, setForm] = useState({
    nombre: "",
    dni: "",
    email: "",
    telefono: "",
    tipo: "Queja",
    descripcion: "",
  });
  const [enviado, setEnviado] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí se puede conectar al backend cuando esté listo
    setEnviado(true);
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <span className={styles.bookIcon}>📋</span>
          <h1 className={styles.title}>Libro de Reclamaciones</h1>
          <p className={styles.subtitle}>
            Conforme a lo establecido en el Código de Protección y Defensa del Consumidor, contamos
            con un Libro de Reclamaciones a tu disposición.
          </p>
        </div>

        {enviado ? (
          <div className={styles.successBox}>
            <span className={styles.successIcon}>✓</span>
            <h2>Tu reclamación fue registrada</h2>
            <p>En breve nos comunicaremos contigo para darte seguimiento.</p>
          </div>
        ) : (
          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.formGrid}>
              <div className={styles.field}>
                <label className={styles.label}>Nombre completo *</label>
                <input
                  className={styles.input}
                  type="text"
                  name="nombre"
                  placeholder="Ingresa tu nombre completo"
                  value={form.nombre}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>DNI / Documento *</label>
                <input
                  className={styles.input}
                  type="text"
                  name="dni"
                  placeholder="Número de documento"
                  value={form.dni}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Correo electrónico *</label>
                <input
                  className={styles.input}
                  type="email"
                  name="email"
                  placeholder="correo@ejemplo.com"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Teléfono</label>
                <input
                  className={styles.input}
                  type="tel"
                  name="telefono"
                  placeholder="Número de contacto"
                  value={form.telefono}
                  onChange={handleChange}
                />
              </div>
              <div className={styles.field} style={{ gridColumn: "1 / -1" }}>
                <label className={styles.label}>Tipo de reclamación *</label>
                <select
                  className={styles.select}
                  name="tipo"
                  value={form.tipo}
                  onChange={handleChange}
                  required
                >
                  <option value="Queja">Queja</option>
                  <option value="Reclamo">Reclamo</option>
                </select>
              </div>
              <div className={styles.field} style={{ gridColumn: "1 / -1" }}>
                <label className={styles.label}>Descripción *</label>
                <textarea
                  className={styles.textarea}
                  name="descripcion"
                  placeholder="Describe detalladamente tu queja o reclamo..."
                  value={form.descripcion}
                  onChange={handleChange}
                  rows={5}
                  required
                />
              </div>
            </div>
            <button type="submit" className={styles.btn}>
              Enviar reclamación
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
